import type { GiscusProps } from '@giscus/react'

/**
 * This type represents the configuration of the site.
 * It should not be edited, unless you wish to add additional configurations.
 */
export type SiteConfigProps = {
  /**
   * Giscus comment sections configuration.
   * @see https://giscus.app
   */
  giscus: GiscusProps & {
    /**
     * @default true
     */
    enabled: boolean
  }
}

const SiteConfig: SiteConfigProps = {
  giscus: {
    enabled:
      process.env.NEXT_PUBLIC_GISCUS_REPO && process.env.NEXT_PUBLIC_GISCUS_REPO_ID && JSON.parse(process.env.NEXT_PUBLIC_GISCUS_ENABLED ?? 'false')
        ? true
        : false,
    lang: 'en',
    loading: 'lazy',
    reactionsEnabled: '1',
    inputPosition: 'bottom',
    repo: process.env.NEXT_PUBLIC_GISCUS_REPO as `${string}/${string}`,
    repoId: process.env.NEXT_PUBLIC_GISCUS_REPO_ID as string,
    category: process.env.NEXT_PUBLIC_GISCUS_CATEGORY,
    categoryId: process.env.NEXT_PUBLIC_GISCUS_CATEGORY_ID,
    strict: '1',
    emitMetadata: '0',
    mapping: 'specific',
    theme: process.env.NEXT_PUBLIC_GISCUS_THEME ?? 'light',
  },
}

export default SiteConfig
